import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { staffApi } from '@/lib/staffApi';

export function PendingMessages() {
    const [data, setData] = useState(null), [error, setError] = useState(''), [offset, setOffset] = useState(0);
    const load = useCallback(() => {
        setError(''); setData(null);
        staffApi.pendingMessages(offset).then(setData).catch(e => setError(e.message || 'Could not load messages.'));
    }, [offset]);
    useEffect(load, [load]);
    return <section className="space-y-4">
        <h2 className="font-serif text-2xl">Messages to send</h2>
        <p>Outgoing messages waiting to be sent.</p>
        <button className="text-gold" onClick={load}>Refresh</button>
        {error && <p role="alert">{error}</p>}
        {!data && !error && <p>Loading messages…</p>}
        {data?.items.length === 0 && <p>No messages are waiting to be sent.</p>}
        {data?.items.map(m => <article key={m.id} className="glass rounded-2xl p-4 space-y-2 break-words">
            <h3 className="text-white font-semibold">{m.customer_name || 'Client'} · {m.channel}</h3>
            <p>{m.recipient}</p><p>{m.subject || 'Appointment message'}</p>
            <p className="text-sm">{m.scheduled_for ? `Scheduled ${new Date(m.scheduled_for).toLocaleString('en-GB')}` : 'Waiting to be scheduled'}</p>
            {m.note && <p className="text-amber-200">{m.note}</p>}
            {m.appointment_id && <Link className="text-gold" to={`/staff/appointments/${m.appointment_id}`}>View appointment</Link>}
        </article>)}
        <div className="flex gap-4">
            {offset > 0 && <button onClick={() => setOffset(Math.max(0, offset - 30))}>Previous</button>}
            {data && offset + 30 < data.total && <button onClick={() => setOffset(offset + 30)}>Next</button>}
        </div>
    </section>;
}
